import { createTheme } from '@mui/material/styles';
import { ToastTypes } from '@stores/App/types/app';

declare module '@mui/material/styles' {
  interface BreakpointOverrides {
    x1400: true;
  }

  interface Palette {
    custom_background: string;
    custom_field_background: string;
    custom_sidebar: {
      background: string;
    };
    custom_menu: {
      primary_background: string;
      secondary_background: string;
      selected: string;
      hover: string;
      font: string;
    };
    funding_calculator: {
      landing_page: {
        background: string;
        font: string;
        header_background: string;
      };
      main_page: {
        background: string;
        font: string;
        secondary_font: string;
      };
    };
  }

  interface PaletteOptions {
    custom_background?: string;
    custom_field_background?: string;
    custom_sidebar?: {
      background?: string;
    };
    custom_menu?: {
      hover?: string;
      font?: string;
    };
    funding_calculator?: {
      landing_page?: {
        background?: string;
        font?: string;
        header_background?: string;
      };
      main_page?: {
        background?: string;
        font?: string;
        secondary_font?: string;
      };
    };
  }

  interface Theme {
    sizes: {
      mobile: {
        marginTop: string;
      };
    };
    toast: Record<
      ToastTypes,
      {
        background: string;
        text: string;
        heading: string;
      }
    >;
  }

  interface ThemeOptions {
    sizes?: {
      mobile?: {
        marginTop?: string;
      };
    };
    toast?: Record<
      ToastTypes,
      {
        background: string;
        text: string;
        heading: string;
      }
    >;
  }
}

const theme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1200,
      xl: 1536,
      x1400: 1400,
    },
  },
  palette: {
    primary: {
      main: '#2F736E',
    },
    secondary: {
      main: '#2E4A4F',
    },
    error: {
      main: '#FF6347',
      light: '#FFFFFF',
      dark: '#BA1A1A',
      contrastText: '#FFFFFF',
    },
    custom_sidebar: {
      background: '#162C36',
    },
    custom_menu: {
      hover: '#9AD6D1',
      font: '#141F00',
    },
    custom_background: '#F5F5F5',
    custom_field_background: '#ECEFF1',
    funding_calculator: {
      landing_page: {
        background: '#F5F5F5',
        font: '#002F36',
        header_background: '#F5F5F5',
      },
      main_page: {
        background: '#F5F5F5',
        font: '#6B6B6B',
        secondary_font: '#E0E0E0',
      },
    },
  },
  typography: {
    fontFamily: 'Manrope, sans-serif',
  },
  sizes: {
    mobile: {
      marginTop: '48px',
    },
  },
  components: {
    MuiDrawer: {
      styleOverrides: {
        paper: {
          //only for mobile view
          '@media (max-width:900px)': {
            maxHeight: '98dvh',
          },
        },
      },
    },
  },
  toast: {
    success: {
      background: '#D4EDDA', // Light green background for success
      heading: '#155724',
      text: '#155724', // Dark green text for contrast
    },
    error: {
      background: '#FFD2CC', // Light red background for error
      text: '#FF6347', // Darker red text for visibility
      heading: '#FF6347', // Darker red text for visibility
    },
    info: {
      background: '#CCE5FF', // Light blue background for info
      text: '#004085', // Dark blue text for contrast
      heading: '#004085', // Dark blue text for contrast
    },
    default: {
      background: '#162C36', // Light gray background for default
      text: '#B4B4B4', // Dark gray text for neutral messaging
      heading: '#F6F8F9', // Dark gray text for neutral messaging
    },
  },
});

export default theme;
